<p>booking-report works!</p>
